import { render, staticRenderFns } from "./ViewTemplateOld.vue?vue&type=template&id=fa25241e&scoped=true"
import script from "./ViewTemplateOld.vue?vue&type=script&lang=js"
export * from "./ViewTemplateOld.vue?vue&type=script&lang=js"
import style0 from "./ViewTemplateOld.vue?vue&type=style&index=0&id=fa25241e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa25241e",
  null
  
)

export default component.exports